import request from '@/utils/request'

export const getUserInfo = (data: any) =>
  request({
    url: '/api/info',
    method: 'get',
    data
  })
export const login = (data: any) =>
  request({
    url: '/users/userLogin',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const logout = () =>
  request({
    url: '/api/logout',
    method: 'post'
  })

export const gettoken = (data: any) =>
  request({
    url: '/user/login',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const gettoken = (data: any) =>
//   request({
//     url: '/admin',
//     method: 'post',
//     data: data,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
